export default "__VITE_ASSET__BRoI1mcT__"